import * as Html from "../../util/Html.ts";
import * as i18n from "../../i18n.ts";
import { getByCurrencyCode } from "../../lib/Currency.js";
import Icons from "../../svg/Icons.ts";
export {init}
Html.registerWidget('widget/form/input-amount',{init:init})

function init(object){
  var 
    currencyCode = object.attr('data-currency-code'),
    currencyName = getByCurrencyCode(i18n.getShortLanguage(),currencyCode).name,
    initialValue = parseFloat(object.attr('data-value'));
  
  object.html(`
<icon data-add="-1" class="rounded" style="border: var(--border);font-size: 30px;box-sizing: content-box;">${Icons.ic_minus}</icon>
<div class="flexauto" style="text-align:center;overflow:visible">
  <input class="flexauto" name="amount" data-currency-display="false" type="amount" data-currency-code="${currencyCode}" style="border:none;text-align:center;color:inherit;font: normal normal bold 40px/47px Roboto;">
  <span style="text-transform:capitalize">${currencyName}</span>
</div>
<icon data-add="1" class="rounded" style="border: var(--border);font-size: 30px;box-sizing: content-box;">${Icons.ic_add_plus}</icon>`);  
  
  var 
    input = object.find('input').amountValue(initialValue);
  
  object.find('icon').on('click',function(){
    var 
      add = parseInt($(this).attr('data-add')),
      result = input.amountValue()+add;
    input.amountValue(result)
  })
  input.on('blur',function(){
    var 
      result = input.amountValue();
    input.amountValue(result)
  })
}